document.addEventListener('DOMContentLoaded', () => {
    const toggles = document.querySelectorAll('[data-component="transcript-toggle"]');

    if (!toggles.length) {
        return;
    }

    toggles.forEach(toggle => {
        toggle.addEventListener('click', () => handleTranscriptToggle(toggle));
    });

    const handleTranscriptToggle = (toggle) => {
        const content = toggle.closest('[data-component="video-transcript"]').querySelector('[data-component="transcript-content"]');
        if (!content) {
            return;
        }
    
        const isHidden = content.classList.toggle('tw-hidden');
        toggle.textContent = isHidden ? 'View Transcript' : 'Hide Transcript';
    }
    
});